










import Vue from 'vue';
import Header from '~/components/layouts/Header.vue';
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';

import BuyapowaRefer from './components/BuyapowaRefer.vue';

export default Vue.extend({
    name: 'Referrals',
    components: {
        Header,
        BuyapowaRefer,
        MainLayout,
    },
});
